export default __webpack_public_path__ + "static/media/car_charge.03c8d27f.jpg";